import { Injectable } from "@angular/core";
import Clarity from "@microsoft/clarity";

@Injectable({
  providedIn: "root",
})
export class ClarityService {
  clarity: typeof Clarity;

  constructor() {
    Clarity.init("512vm5yr7n");
    this.clarity = Clarity;
  }
}
